import { useTranslation } from "react-i18next";
import { Autocomplete, Chip, styled, TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import { useState } from "react";

const CustomTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: '12px',
    backgroundColor: 'var(--inputs)',
    color: 'var(--black)',
    fontSize: '0.9rem',
    minHeight: '52px',
    paddingLeft: '8px !important',
    paddingTop: '8px !important',
    paddingBottom: '8px !important',
    overflow: 'hidden',
    '& fieldset': {
      border: 'none',
    },
  },
  '& .MuiInputLabel-root': {
    position: 'static',
    transform: 'none',
    fontSize: '0.75rem',
    color: 'var(--secondary-text)',
    marginBottom: theme.spacing(0.5),
  },
  '& .MuiChip-filled': {
    background: 'var(--background-card)',
  },
  '& .MuiIconButton-root': {
    color: 'var(--black)',
  },
  '& .MuiAutocomplete-popupIndicator': {
    padding: '14.6px',
    marginRight: '0',
    borderRadius: 0,
    borderTopRightRadius: '12px',
    borderBottomRightRadius: '12px',
    transform: 'translate(10px, 0px)',
    background: 'var(--input-gradient)',
    color: 'var(--black)',

    [theme.breakpoints.down('sm')]: {
      // background: 'transparent', // or backgroundColor if you prefer
      // paddingLeft: '5px',
      // paddingRight: '5px',
    },
  },
}));

const CustomMultiSelectDropdown = ({ properties, methods }) => {
  const {
    name,
    label,
    dropDownList,
    isDisabled,
    placeholder,
    customOnChange,
    validation,
    required,
    readOnly,
  } = properties;

  const { control, setValue } = methods;
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const customRules = {
    ...validation,
    required: {
      value: validation?.required?.value || required,
      message:
        validation?.required?.message || `${label.charAt(0).toUpperCase() + label.slice(1).toLowerCase()} ${t('Common.Is Required')}`,
    },
  };

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({
          field: { ref, value, onChange, onBlur, ...field },
          fieldState: { error },
        }) => (
          <Autocomplete
            {...field}
            multiple
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            onInputChange={(event, newInputValue, reason) => {
              if (reason === "input") {
                setOpen(true);  
              } else {
                setOpen(false); 
              }
            }}
            limitTags={3}
            value={value ?? []}
            readOnly={readOnly}
            disabled={isDisabled}
            options={dropDownList || []}
            placeholder={placeholder}
            getOptionLabel={(option) => option.label}
            onChange={(event, newValue) => {
              customOnChange && customOnChange(newValue);
              onChange(newValue);
              if (!newValue) setValue(name, null);
            }}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => {
                const { key, ...tagProps } = getTagProps({ index });
                return <Chip key={key} {...tagProps} label={option.label} />;
              })
            }
            filterSelectedOptions
            noOptionsText={'No option'}
            isOptionEqualToValue={(options, value) =>
              options.value === value.value
            }
            size='small'
            onBlur={onBlur}
            renderInput={(params) => (
              <CustomTextField
                {...params}
                id='demo-simple-select-readonly'
                ref={ref}
                label={label}
                error={!!error}
                helperText={error ? error.message : null}
                required={validation?.required?.value || required}
              />
            )}
          />
        )}
        rules={customRules}
      />
    </>
  );
};

export default CustomMultiSelectDropdown;
